import { AttributeFiles } from '@organice/graphql'
import { AttributeValueUpload, UploadFile, VersionedValueUpload } from './types'

export const convertValueUploadsToFileList = (
  data?: VersionedValueUpload[] | UploadFile[],
  attributeFiles?: {
    downloadUrl?: AttributeFiles['downloadUrl']
    file: Pick<AttributeFiles['file'], 'id' | 'name' | 'size' | 'extension'>
  }[],
  roomAttributeFiles?: {
    downloadUrl?: AttributeFiles['downloadUrl']
    file: Pick<AttributeFiles['file'], 'id' | 'name' | 'size' | 'extension'>
  }[]
): UploadFile[] => {
  let files: UploadFile[] = []

  if (attributeFiles) {
    files = attributeFiles?.map(aF => {
      return {
        uid: aF.file.id,
        name: aF.file.name,
        url: aF.downloadUrl as string,
        size: aF.file.size,
        type: 'attributeFile',
        extension: aF.file.extension,
      }
    })
  }

  if (roomAttributeFiles) {
    files = roomAttributeFiles?.map(aF => {
      return {
        uid: aF.file.id,
        name: aF.file.name,
        url: aF.downloadUrl as string,
        size: aF.file.size,
        type: 'roomAttributeFile',
        extension: aF.file.extension,
      }
    })
  }
  if (data) {
    files = [
      ...files,
      ...convertAttributeValueUploadsToFileList(data as AttributeValueUpload[]),
    ]
  }
  return files
}

export const convertAttributeValueUploadsToFileList = (
  uploads?: AttributeValueUpload[]
): UploadFile[] => {
  return (uploads || []).flatMap(upload => {
    const uploadVersions =
      upload.attributeValueUploadVersions ||
      upload.roomAttributeValueUploadVersions ||
      upload.eventAttributeValueUploadVersions ||
      []
    const [latest, ...previousVersions] = uploadVersions
    if (!latest) return []
    const versionFileIds = uploadVersions.map(v => v.file.id)
    return [
      {
        uid: String(latest.file.id),
        name: latest.file.name,
        url: latest.downloadUrl || undefined,
        size: latest.file.size,
        extension: latest.file.extension,
        uploadedBy: latest.file.user ?? null,
        createdAt: latest.file.createdAt,
        uploadId: upload.id,
        versionFileIds,
        versions: previousVersions.map(v => ({
          uid: String(v.file.id),
          name: v.file.name,
          url: v.downloadUrl || undefined,
          size: v.file.size,
          extension: v.file.extension,
          uploadedBy: v.file.user ?? null,
          createdAt: v.file.createdAt,
        })),
      },
    ]
  })
}
